module.exports = __webpack_public_path__ + "img/pakiety_snr.499be983.svg";